import {Fragment, lazy, Suspense} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Button, {atomButtonColors, atomButtonShapes} from '@s-ui/react-atom-button'
import {spinnerBasicOverlayTypes, spinnerBasicSizes, spinnerBasicTypes} from '@adv-mt/mt-spinner-basic'
import IconCheck from '@adv-mt/mt-svg-icons/lib/Check'
import IconCall from '@adv-mt/mt-svg-icons/lib/PhoneCallOutline'

import {DESIGNS, SIZES} from './config.js'

const DEFAULT_COLOR = 'accent'

const SpinnerBasic = lazy(() => import(/* webpackChunkName: "SpinnerBasic" */ '@adv-mt/mt-spinner-basic'))

function LeadPhoneCallButton({
  color = DEFAULT_COLOR,
  design,
  isAlreadyContacted,
  isFullWidth,
  isLoading,
  isPhoneRevealed = false,
  negative,
  onClick = () => {},
  showIcon = true,
  size,
  text
}) {
  const buttonProps = {
    color,
    design,
    disabled: isAlreadyContacted,
    negative,
    size: 'medium',
    ...(showIcon && {
      leftIcon: isAlreadyContacted ? <IconCheck size="medium" /> : <IconCall />
    })
  }

  const LoadingIcon = (
    <Suspense fallback={Fragment}>
      <SpinnerBasic
        overlayType={spinnerBasicOverlayTypes.TRANSPARENT}
        size={spinnerBasicSizes.SMALL}
        type={spinnerBasicTypes.SECTION}
      />
    </Suspense>
  )

  return (
    <Button
      {...buttonProps}
      color={color}
      fullWidth={isFullWidth}
      isButton
      isFitted
      leftIcon={isLoading ? LoadingIcon : buttonProps.leftIcon}
      onClick={onClick}
      shape={atomButtonShapes.CIRCULAR}
      size={size}
    >
      <span className={cx('mt-LeadPhoneCall-buttonText', {'mt-LeadPhoneCall-buttonText--revealed': isPhoneRevealed})}>
        {text}
      </span>
    </Button>
  )
}

LeadPhoneCallButton.displayName = 'LeadPhoneCallButton'
LeadPhoneCallButton.propTypes = {
  color: PropTypes.oneOf(Object.values(atomButtonColors)),
  design: PropTypes.oneOf(Object.values(DESIGNS)),
  isAlreadyContacted: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPhoneRevealed: PropTypes.bool,
  negative: PropTypes.bool,
  onClick: PropTypes.func,
  showIcon: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
  text: PropTypes.string.isRequired
}

export default LeadPhoneCallButton
